export default {
    setDocumentTitle(title){
        if (!title){
            title = this.$route.name;
        }
        // if (title === 'welcome'){
        //     document.title = '';
        // }else{
        //     document.title = this.$t('document-title', [this.$t(`routes.${title}`)]);
        // }
    },
    asset(name, type=null, publicPath=true){
        let path = process.env.VUE_APP_ASSETS_PATH ? process.env.VUE_APP_ASSETS_PATH : (publicPath ? '/' : '@/assets');
        if (path.slice(-1) !== '/'){
            path += '/';
        }
        if (type){
            const imageTypes = ['img', 'imgs', 'image', 'images'];
            if (imageTypes.includes(type)){
                path += 'img/';
            }
        }
        return path + name;
    },
    showMsg(text, color = 'error', topBar=false, loading=false, timeout = 4000){
        this.$store.dispatch('addSnackMsg', {show: true, text: text, color: color, timeout: timeout, msgBar: topBar, progress: loading});
    },
    closeMsg(){
        this.snackMsg = {show: false, text: '', msgBar: true, closeMsg: true};  // closeMsg to prevent infinity loop
    },
    setLinearLoading(loading=true){
        let timeout = loading ? 20 : 300;
        window.setTimeout(()=>{
            this.$store.commit('SET_LINEAR_LOADING', loading);
        }, timeout)
    },
    numFormat(value){
        let formated = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return formated;
    },
    unitFormat(value, single, dual, plural){
        let unit = single;
        if (value == 1){
            return "1 " + single;
        }else if (value == 2){
            return dual;
        }else if (value <= 10){
            unit = plural;
        }
        return `${this.numFormat(value)} ${unit}`;
    },
    moneyFormat(value){
        return this.numFormat( parseFloat(value).toFixed(2) );
    },
    handleStatus(status){
        let statusColor = '',
            statusText = '';
        switch (status) {
            case 'review':
                statusColor = 'indigo';
                statusText = 'قيد المراجعة';
                break;

            case 'pending':
                statusColor = 'blue-grey';
                statusText = 'معلق';
                break;

            case 'completed':
                statusColor = 'success';
                statusText = 'مكتمل';
                break;
            case 'approved':
                statusColor = 'success';
                statusText = 'مُعتمد';
                break;

            case 'canceled':
                statusColor = 'red';
                statusText = 'ملغي';
                break;

            case 'suspended':
                statusColor = 'red';
                statusText = 'محظور';
                break;

            case 'not-verified':
                statusColor = 'orange';
                statusText = 'غير مفعل';
                break;

            case 'active':
                statusColor = 'success';
                statusText = 'نشط';
                break;

            case 'expired':
                statusColor = 'red';
                statusText = 'منتهي';
                break;

            case 'used':
                statusColor = 'grey darken-1';
                statusText = 'مُستخدم';
                break;

            case 'not-approved':
                statusColor = 'orange';
                statusText = 'معلّق';
                break;

            case 'reviewed':
                statusColor = ''; // light...
                statusText = 'تم المراجعة';
                break;

            case 'unread':
                statusColor = 'primary';
                statusText = 'غير مقروء';
                break;

            case 'default':
                statusColor = 'blue-grey';
                statusText = 'افتراضي';
                break;

            case 'featured':
                statusColor = 'orange';
                statusText = 'مميز';
                break;

            case 'hidden':
                statusColor = 'black';
                statusText = 'مخفي';
                break;

            default:
                statusColor = 'black';
                statusText = status;
                break;
        }
        return {color: statusColor, text: statusText}
    },
    scrollToTop(){
        let scrollQuery = this.$route.query && this.$route.query.scrollTo ? this.$route.query.scrollTo : null;
        window.setTimeout(()=>{
            
            let el = document.documentElement;
            if (scrollQuery){
                let scrollTo = this.$refs[this.$route.query.scrollTo];
                this.scrollToElement(scrollTo);
            }else{
                // el.scrollTop = 0;
                if (el.scrollTop > 50){
                    this.$vuetify.goTo(0, {container: el});
                }
            }
        }, scrollQuery ? 400 : 250);
    },
    scrollToElement(scrollTo){
        let el = document.documentElement;
        if (scrollTo){
            this.$vuetify.goTo(scrollTo, {container: el});
        }
    },
    goBack(){
        this.$router.go(-1);
    },
    timeFormat(time) {
        if (time == 'now') {
            return 'اﻵن';
        }

        // Split timestamp into [ Y, M, D, h, m, s ]
        var t = time.split(/[- :]/); // splitting timestamp into array t[], so t[0] is the year .. etc

        // Apply each element to the Date function
        // var d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0
        var d = new Date(new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0

        d.setTime(d.getTime());

        var since = this.timeSince(d);
        return since;
    },
    timeSince (d) {
        var ms = new Date() - d;
        if (ms < 0){
            return `${d.getFullYear()}/${d.getMonth()+1}/${d.getDate()}`;
        }

        var seconds = Math.floor(ms / 1000);

        var interval = Math.floor(seconds / 31536000);

        if (interval >= 1) {
            if (interval == 1) {
                return "منذ عام واحد";
            } else if (interval == 2) {
                return "منذ عامين";
            } else if (interval <= 10) {
                return "منذ " + interval + " أعوام";
            } else {
                return "منذ " + interval + " عام";
            }
        }


        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            if (interval == 1) {
                return "منذ شهر واحد";
            } else if (interval == 2) {
                return "منذ شهرين";
            } else if (interval <= 10) {
                return "منذ " + interval + " شهور";
            } else {
                return "منذ " + interval + " شهر";
            }
        }


        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            if (interval == 1) {
                return "منذ يوم واحد";
            } else if (interval == 2) {
                return "منذ يومين";
            } else if (interval <= 10) {
                return "منذ " + interval + " أيام";
            } else {
                return "منذ " + interval + " يوم";
            }
        }


        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            if (interval == 1) {
                return "منذ ساعة واحدة";
            } else if (interval == 2) {
                return "منذ ساعتين";
            } else if (interval <= 10) {
                return "منذ " + interval + " ساعات";
            } else {
                return "منذ " + interval + " ساعة";
            }
        }


        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
            if (interval == 1) {
                return "منذ دقيقة واحدة";
            } else if (interval == 2) {
                return "منذ دقيقتين";
            } else if (interval <= 10) {
                return "منذ " + interval + " دقائق";
            } else {
                return "منذ " + interval + " دقيقة";
            }

        }

        return 'اﻵن';

    },
    dateTimeFormat(time){

        // Split timestamp into [ Y, M, D, h, m, s ]
        var t = time.split(/[- :]/); // splitting timestamp into array t[], so t[0] is the year .. etc
        // Apply each element to the Date function
        // var d = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0
        var d = new Date(new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0
        d.setTime(d.getTime());
        let month = d.getMonth()+1;
        let day = d.getDate();
        if (month < 10){
            month = "0" + month;
        }
        if (day < 10){
            day = "0" + day;
        }

        let hours = d.getHours();
        let minutes = d.getMinutes();
        let ampm = 'AM';
        if (hours >= 12){
            ampm = 'PM';
        }
        if (hours > 12){
            hours -= 12;
        }

        if (minutes < 10){
            minutes = "0" + minutes;
        }
        if (hours < 10){
            hours = "0" + hours;
        }
        return `${d.getFullYear()}-${month}-${day} | ${hours}:${minutes} ${ampm}`;
    },
    toDateTimeString(d){
        d.setTime(d.getTime());
        let month = d.getMonth()+1;
        let day = d.getDate();
        if (month < 10){
            month = "0" + month;
        }
        if (day < 10){
            day = "0" + day;
        }

        let hours = d.getHours();
        let minutes = d.getMinutes();
        let seconds = d.getSeconds();

        if (seconds < 10){
            seconds = "0" + seconds;
        }
        if (minutes < 10){
            minutes = "0" + minutes;
        }
        if (hours < 10){
            hours = "0" + hours;
        }
        return `${d.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
}